var _g, _line, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodToBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 565.1 619",
    enableBackground: "new 0 0 565.1 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 72.9,
    y1: 100.6,
    x2: 72.9,
    y2: 515
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,103.2 72.9,87.7 81.9,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,512.4 72.9,528 81.9,512.4  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 607.4,
    x2: 480,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M489.6,607.5v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H489.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M500.4,607.5v-13.3h1.7V606h6.2v1.5H500.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M510.8,604.3c-0.5-1-0.8-2.2-0.8-3.5c0-1.3,0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5c0.6,1,0.8,2.2,0.8,3.5c0,1.3-0.3,2.5-0.8,3.5c-0.6,1-1.3,1.9-2.4,2.5 c-1,0.6-2.2,0.9-3.5,0.9c-1.3,0-2.4-0.3-3.5-0.9C512.1,606.2,511.3,605.4,510.8,604.3z M511.7,600.8c0,1,0.2,2,0.6,2.8 c0.4,0.8,1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7c1,0,1.8-0.2,2.6-0.7c0.8-0.5,1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8 c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5S511.7,599.2,511.7,600.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M526.1,604.3c-0.5-1-0.8-2.2-0.8-3.5c0-1.3,0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5c0.6,1,0.8,2.2,0.8,3.5c0,1.3-0.3,2.5-0.8,3.5c-0.6,1-1.3,1.9-2.4,2.5 c-1,0.6-2.2,0.9-3.5,0.9c-1.3,0-2.4-0.3-3.5-0.9C527.4,606.2,526.6,605.4,526.1,604.3z M526.9,600.8c0,1,0.2,2,0.6,2.8 s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7c1,0,1.8-0.2,2.6-0.7c0.8-0.5,1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8 c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5S526.9,599.2,526.9,600.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M541.1,607.5v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H541.1z M542.7,600.7 h3.5c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8c0-0.8-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V600.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 78.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 415.3,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodToBottom);
export default __webpack_public_path__ + "static/media/RodToBottom.4731a95df8f3b0d165c24cf0c01ca807.svg";
export { ForwardRef as ReactComponent };